webpackJsonp([193380515384119],{

/***/ 810:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Webpack = __webpack_require__(24);
	
	var _Webpack2 = _interopRequireDefault(_Webpack);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Webpack2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Introduction'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Lore uses ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://webpack.github.io/' },
	        'Webpack'
	      ),
	      ' for the build system.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If you\'re new to webpack, you may find ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://egghead.io/courses/using-webpack-for-production-javascript-applications' },
	        'this video series by Kent Dodds'
	      ),
	      ' helpful for getting up to speed quickly. You can also check out the ',
	      _react2.default.createElement(
	        'a',
	        { href: 'http://webpack.github.io/docs/tutorials/audience/' },
	        'Official Tutorial'
	      ),
	      ' on the webpack website.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The config file for webpack is located at the root of the project and called ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'webpack.config.js'
	      ),
	      '. It uses a library called ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/kentcdodds/webpack-config-utils' },
	        'webpack-config-utils'
	      ),
	      ', created by Kent Dodds, in order to allow multiple environment configurations to live within the same config file, such as different configurations for development and production.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The config file includes defaults intended to cover the majority of application development concerns, which includes:'
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'Support for common CSS preprocessors (LESS and SASS)'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Support for common font types (ttf, otf, eot, woff, woff2)'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Support for common image types (png, jpeg, gif, tiff, bmp, svg)'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Automatically adds browser prefixes to CSS files'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Favicon generation and insertion into the HTML file'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Chunking (breaking the build up into multiple smaller files for faster page load)'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Cache busting (adding a unique hash to production files to prevent browsers from re-using outdated files)'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'It\'s entirely possible you may never need to modify the config file. If you do, you can learn about the configuration options in ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://webpack.js.org/configuration' },
	        'the official webpack documentation'
	      ),
	      '.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-webpack-index-js-f2a43b7bac7adc7324ce.js